function sumUpOpeningHours(openingHours) {
    const formattedOpeningHours = {};
    openingHours = JSON.parse(JSON.stringify(openingHours));

    // remove closed days
    if (openingHours.Saturday) {
        if (openingHours.Saturday.trim().toLowerCase() === 'closed') {
            delete openingHours.Saturday;
        }
    }
    if (openingHours.Sunday) {
        if (openingHours.Sunday.trim().toLowerCase() === 'closed') {
            delete openingHours.Sunday;
        }
    }

    // if mon - friday is all the same, sum those up to one line
    if (
        openingHours.Monday && openingHours.Tuesday && openingHours.Monday === openingHours.Tuesday &&
        openingHours.Wednesday && openingHours.Monday === openingHours.Wednesday &&
        openingHours.Thursday && openingHours.Monday === openingHours.Thursday &&
        openingHours.Friday && openingHours.Monday === openingHours.Friday
    ) {
        const commonOpeningHours = openingHours.Monday;
        delete openingHours.Monday;
        delete openingHours.Tuesday;
        delete openingHours.Wednesday;
        delete openingHours.Thursday;
        delete openingHours.Friday;

        formattedOpeningHours['Mon - Fr '] = commonOpeningHours;
    }

    for (const day in openingHours) {
        formattedOpeningHours[day] = openingHours[day];
    }

    return formattedOpeningHours;
}

export default sumUpOpeningHours;
